// @flow
// import icons from '../../../assets/styles/icons.scss';
import update from 'immutability-helper/index';

import type { OnlineStoreCategory } from '../../../entities';

/*function populateStoreCategories(categories: Category[]): Category[] {
  return categories.map((c: Category) => {
    let icon = icons.iconCategoryOthers;
    let translateId = 'category.others';

    const foundCategory = DEFAULT_CATEGORIES.find((fc: Category) => fc.id === c.id);
    if (foundCategory) {
      icon = foundCategory.icon;
      translateId = foundCategory.translateId;
    }
    return update(c, { icon: { $set: icon }, translateId: { $set: translateId } });
  });
}*/

function indexStoreCategoriesById(categories: OnlineStoreCategory[]): { [key: number]: OnlineStoreCategory } {
  return categories.reduce((acum: { [key: number]: OnlineStoreCategory }, c: OnlineStoreCategory) =>
    update(acum, {
      [c.id]: {
        $set: c
      },
    }), {});
}

export {
  indexStoreCategoriesById,
};



// WEBPACK FOOTER //
// ./src/modules/local-values/utils/store-categories.js